(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cicibici-footer"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button) return;
    const error = document.getElementById(button.getAttribute('aria-describedby'));
    if (error) error.hidden = true;
    button.disabled = true;
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Privacy panel unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      if (error) error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
